import { Box, Button } from '@kluein/klue-ui';
import { CaretDown, Funnel } from '@phosphor-icons/react';
import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import TEST_IDS from 'test-ids';
import TRACKING_IDS from 'tracking-ids';

import GroupDropContent, { DROP_WIDTH } from './GroupDropContent';

import type { RivalGroupType } from 'api/api.types';

export type DropProps = {
  onSelectGroup: (group: number | undefined) => void;
  rivalGroups: RivalGroupType[];
  group: number | undefined;
  iconOnly?: boolean;
};

function GroupDrop(props: DropProps) {
  const groupRef = useRef<HTMLDivElement>(null);
  const { onSelectGroup, rivalGroups, group, iconOnly = false } = props;
  const { t } = useTranslation();
  const groupName =
    useMemo(() => {
      if (group === 0) {
        return t('Dashboard:filters.allCompanies');
      }
      if (group) {
        return rivalGroups.find((rivalGroup) => rivalGroup.id === group)?.name;
      }
    }, [group, rivalGroups, t]) || t('Dashboard:filters.allGroups');

  return (
    <Box
      align="center"
      direction="row"
      ref={groupRef}
      width={{ max: DROP_WIDTH }}
      flex={false}
      data-test-id={TEST_IDS.dashboard.filterDrops.group.drop}
    >
      <Button
        label={iconOnly ? '' : groupName}
        dropContent={
          <GroupDropContent
            group={group}
            onSelectGroup={onSelectGroup}
            rivalGroups={rivalGroups}
          />
        }
        dropAlign="right"
        alignSelf="center"
        variant="flat"
        leftSlot={<Funnel />}
        rightSlot={iconOnly ? undefined : <CaretDown />}
        data-test-id={TEST_IDS.dashboard.filterDrops.group.dropButton}
        data-tracking-id={TRACKING_IDS.dashboard.filters.groupDrop.button}
      />
    </Box>
  );
}

export default GroupDrop;
